<template>
  <el-dialog
    title="工作区成员"
    :visible.sync="value.visible"
    width="700px"
    :destroy-on-close="true"
    append-to-body
    class="dlg-mem-list"
    @open="onDlgOpen"
    @closed="onDlgClosed"
  >
    <div>

      <div class="has-bg-whiteless row-wrap py-2_5 px-4 border-t">

        <el-input v-model="keywords" class="mr-2 my-1" placeholder="搜索成员名称" style="width: 200px" @change="onSearch">
          <template #append>
            <el-button @click="onSearch"><i class="iconfont icon-search " /></el-button>
          </template>
        </el-input>
        <el-select v-model="tagValue" v-loading="$store.state.app.loadingList.includes('listTag')" class="mr-2 my-1" placeholder="标签分类" @change="onTagChange">
          <el-option v-for="item in tagList" :key="item.id.toString()" :label="item.tag" :value="item.id.toString()" />
        </el-select>
        <div class="grow" />
      </div>

      <div v-loading="$store.state.app.loadingList.includes('listOrgUser')">
        <div v-if="list && list.items.length <= 0" class="has-bg-white border-radius-bottom-m has-text-light text-center py-2_5 px-4"><el-empty :image-size="100" description="暂无数据" /></div>

        <div v-if="list && list.items.length > 0" class="has-bg-white border-radius-bottom-m">
          <div v-for="item in list.items" :key="item.id.toString()" class=" row-wrap py-2_5 px-4 my-list-item">
            <div class="grow py-2_5">
              <div class="is-fs-l">
                <!-- <span class="iconfont icon-file-text" /> -->
                <span class="mr-2">{{ item.nickname }}</span>
                <el-tag v-if="item.role === 2" type="primary" size="mini" effect="dark">管理员</el-tag>
              </div>
            </div>
            <el-button v-if="!excludeUserIds.includes(item.user_id.toString())" type="success" plain size="mini" @click="onAddFormUser(item)">添加</el-button>
            <div v-else class="has-text-light">已添加</div>
          </div>
        </div>
      </div>

      <div class="my-2_5 flex-center">
        <el-pagination
          :page-size="perPage"
          layout="prev, pager, next"
          :background="true"
          :total="totalCount"
          :hide-on-single-page="totalCount <= perPage"
          :current-page="pageNo"
          @current-change="onPageChange"
        />
      </div>

    </div>

  </el-dialog>

</template>

<script>
import { listOrgUser } from '@/api/org'
import { createFormUser } from '@/api/form'
import { listTag } from '@/api/util'
import config from '@/config/index'

export default {
  name: 'DlgMemList',
  components: {

  },
  props: {
    value: {
      type: Object,
      default: () => ({
        visible: false
      })
    },
    params: {
      type: Object,
      default: () => ({
        formId: '',
        excludeUserIds: []
      })
    }
  },
  emits: ['ok', 'cancel'],
  data() {
    return {
      list: null,
      pageNo: 1,
      keywords: '',
      tagList: [],
      tagValue: '',

      excludeUserIds: [],
      isChanged: false,

      role: [{
        value: '2',
        label: '管理员'
      }, {
        value: '3',
        label: '成员'
      }]
    }
  },
  computed: {
    dataQuery() {
      const q = `?id=${this.$route.params.id}&search=${this.keywords}&tag=${this.tagValue}&page=${this.pageNo}`
      return q
    },
    perPage() {
      return this.list?._meta?.perPage || 30
    },
    totalCount() {
      return this.list?._meta?.totalCount || 0
    }
  },
  watch: {
  },
  created() {
  },
  mounted() {

  },

  methods: {
    async fetchData(query) {
      const data = await listOrgUser({
        query: query
      }, 'listOrgUser')
      console.log(data)
      this.list = data
    },
    async listTag(query) {
      this.tagList = await listTag({
        query: `?org_id=${this.$route.params.id}&tag_type=${config.TAG_TYPE_MEM}`
      }, 'listTag')
      this.tagList.unshift({
        id: '',
        tag: '全部'
      })
    },
    async saveFormUser(item) {
      const that = this

      const res = await createFormUser({
        form_id: that.params.formId,
        account: item.user_id
      }, 'createFormUser')
      console.log(res)

      that.excludeUserIds.push(item.user_id.toString())
      that.isChanged = true
      return res
    },
    async onAddFormUser(item) {
      await this.saveFormUser(item)
    },
    async onDlgOpen() {
      this.isChanged = false
      console.log(this.params.excludeUserIds)
      this.excludeUserIds = [...this.params.excludeUserIds]
      console.log(this.excludeUserIds)
      this.fetchData(this.dataQuery)
      this.listTag()
    },
    onSearch() {
      this.pageNo = 1
      this.fetchData(this.dataQuery)
    },
    onTagChange() {
      this.pageNo = 1
      this.fetchData(this.dataQuery)
    },
    // 切换页码
    onPageChange(pageNo) {
      this.pageNo = pageNo
      this.fetchData(this.dataQuery)
      document.querySelector('.dlg-mem-list').scrollIntoView()
    },
    onDlgClosed() {
      this.$emit('closed', this.isChanged)
    },

    onCancel() {
      console.log('cancel')
      this.value.visible = false
      this.$emit('cancel')
    },
    async onOk() {
      // const that = this
      console.log('ok')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped></style>
